import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-838c9d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-fixed" }
const _hoisted_2 = { class: "app-bar" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-logo" }, "edcircle", -1))
const _hoisted_6 = {
  key: 0,
  class: "btns-container d-flex gap"
}
const _hoisted_7 = {
  key: 1,
  class: "btns-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_locale_picker = _resolveComponent("locale-picker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "logo-container",
        to: "/",
        custom: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onLogoClicked()))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: require('../../../assets/441.png'),
                alt: "medcircle",
                class: "logo",
                style: {"border-radius":"8px","margin-right":"4px"}
              }, null, 8, _hoisted_4),
              _hoisted_5
            ])
          ])
        ]),
        _: 1
      }),
      (!_ctx.smallWindow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_locale_picker),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerProps, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.text
              }, [
                (item.path)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: item.path
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "text-none text-subtitle-1",
                          variant: "text",
                          color: "white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (item.subitems)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 1,
                      "offset-y": "",
                      "open-on-hover": _ctx.isTouchScreen ? false : true
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: "text-none text-subtitle-1",
                          variant: "text",
                          color: "white"
                        }, props), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text) + " ", 1),
                            (item.photo)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 0,
                                  src: item.photo,
                                  width: 30,
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  right: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-chevron-down")
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, { style: {"background-color":"#1e293c"} }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subitems, (subitem) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: subitem.text,
                                to: subitem.path
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "white",
                                    right: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subitem.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_btn, {
                                    class: "text-none text-subtitle-1 ml-2",
                                    variant: "text",
                                    color: "white",
                                    style: {"min-width":"120px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subitem.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["open-on-hover"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_locale_picker),
            _createVNode(_component_v_menu, {
              "offset-y": "",
              "close-on-content-click": true,
              eager: "",
              "open-on-hover": _ctx.isTouchScreen ? false : true
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  class: "text-none text-subtitle-1",
                  variant: "text",
                  color: "white"
                }, props), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-menu")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1040)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, { style: {"background-color":"#1e293c"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerProps, (item) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.text
                      }, {
                        default: _withCtx(() => [
                          (item.path)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                to: item.path,
                                class: "text-none text-subtitle-1 ml-2",
                                variant: "text",
                                color: "white",
                                style: {"min-width":"140px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.text), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (item.subitems)
                            ? (_openBlock(), _createBlock(_component_v_menu, {
                                key: 1,
                                "offset-y": "",
                                "open-on-hover": _ctx.isTouchScreen ? false : true,
                                "open-on-click": ""
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps({
                                    class: "text-none text-subtitle-1 ml-2",
                                    variant: "text",
                                    color: "white",
                                    style: {"min-width":"140px"}
                                  }, props), {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.text) + " ", 1),
                                      (item.photo)
                                        ? (_openBlock(), _createBlock(_component_v_img, {
                                            key: 0,
                                            src: item.photo,
                                            width: 30,
                                            style: {"border-radius":"50%"}
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            right: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-chevron-down")
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, { style: {"background-color":"#1e293c"} }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subitems, (subitem) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: subitem.text,
                                          to: subitem.path
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              color: "white",
                                              right: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(subitem.icon), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_btn, {
                                              class: "text-none text-subtitle-1 ml-2",
                                              variant: "text",
                                              color: "white",
                                              style: {"min-width":"120px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(subitem.text), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["open-on-hover"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["open-on-hover"])
          ]))
    ])
  ]))
}